import React from "react";
import { SkeletonCard, SkeletonText } from "../../UI/DesignStandards";

const TeamsSkeleton = () => {
  // Create an array of 6 skeleton team items
  const skeletonTeams = Array.from({ length: 6 }, (_, index) => index);

  return (
    <div className="w-full">
      {skeletonTeams.map((teamIndex) => (
        <SkeletonCard key={`team-${teamIndex}`} className="mb-4" padding="p-4">
          {/* Team Header */}
          <div className="flex items-center justify-between mb-4">
            <div className="flex items-center gap-3">
              {/* Team Name Skeleton */}
              <SkeletonText
                key={`team-name-${teamIndex}`}
                size="lg"
                width="32"
              />
              {/* Team Status Skeleton */}
              <SkeletonText
                key={`team-status-${teamIndex}`}
                size="md"
                width="20"
              />
            </div>
            {/* Action Buttons Skeleton */}
            <div className="flex gap-2">
              <SkeletonText
                key={`action-1-${teamIndex}`}
                size="md"
                width="16"
              />
              <SkeletonText
                key={`action-2-${teamIndex}`}
                size="md"
                width="16"
              />
            </div>
          </div>

          {/* Bowlers Section */}
          <div className="space-y-3">
            {Array.from({ length: 4 }, (_, bowlerIndex) => (
              <div
                key={`bowler-${teamIndex}-${bowlerIndex}`}
                className="flex items-center gap-4"
              >
                {/* Bowler Name */}
                <SkeletonText
                  key={`bowler-name-${teamIndex}-${bowlerIndex}`}
                  size="md"
                  width="24"
                />
                {/* Bowler Average */}
                <SkeletonText
                  key={`bowler-avg-${teamIndex}-${bowlerIndex}`}
                  size="md"
                  width="16"
                />
                {/* Game Scores */}
                <div className="flex gap-2">
                  {Array.from({ length: 3 }, (_, gameIndex) => (
                    <SkeletonText
                      key={`game-${teamIndex}-${bowlerIndex}-${gameIndex}`}
                      size="lg"
                      width="12"
                    />
                  ))}
                </div>
                {/* Total Score */}
                <SkeletonText
                  key={`bowler-total-${teamIndex}-${bowlerIndex}`}
                  size="md"
                  width="16"
                />
              </div>
            ))}
          </div>

          {/* Team Total Section */}
          <div className="mt-4 pt-4 border-t border-gray-200">
            <div className="flex justify-between items-center">
              <SkeletonText
                key={`team-total-label-${teamIndex}`}
                size="lg"
                width="20"
              />
              <SkeletonText
                key={`team-total-value-${teamIndex}`}
                size="lg"
                width="16"
              />
            </div>
          </div>
        </SkeletonCard>
      ))}
    </div>
  );
};

export default TeamsSkeleton;
